import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static passwordMatchValidator(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const passwordControl = formGroup.controls[password];
      const confirmPasswordControl = formGroup.controls[confirmPassword];

      if (!passwordControl || !confirmPasswordControl) {
        return null; // Retorna nulo si los controles no existen
      }

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
        return null; // Retorna nulo si otro validador ya encontró un error en el campo de confirmación de contraseña
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true }); // Establece un error si las contraseñas no coinciden
      } else {
        confirmPasswordControl.setErrors(null); // Limpia los errores si las contraseñas coinciden
      }
    };
  }

  static passwordMatchValidatorV16(password: string, confirmPassword: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control as FormGroup;
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl = formGroup.get(confirmPassword);
  
      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }
  
      if (passwordControl.value !== confirmPasswordControl.value) {
        // Retornamos el error a nivel de formulario en lugar de configurarlo directamente en el control
        return { passwordMismatch: true };
      } else {
        // Si las contraseñas coinciden, limpiamos cualquier error en confirmPassword
        if (confirmPasswordControl.hasError('passwordMismatch')) {
          confirmPasswordControl.setErrors(null);
        }
      }
  
      return null;
    };
  }
}
